import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { LayoutProps } from './types';
import { ImageItem } from './ImageItem';

export const CarouselLayout: React.FC<LayoutProps> = ({
  filteredItems,
  colors,
  data,
  imageRefs,
  onImageClick,
}) => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const currentItem = filteredItems[carouselIndex];

  return (
    <div className="relative">
      {filteredItems.length > 1 && (
        <>
          <button
            onClick={() =>
              setCarouselIndex(prev => (prev > 0 ? prev - 1 : filteredItems.length - 1))
            }
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 p-2 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-colors focus:outline-none z-10"
            aria-label="Previous image"
          >
            <ChevronLeft size={24} className="text-gray-700" />
          </button>
          <button
            onClick={() =>
              setCarouselIndex(prev => (prev < filteredItems.length - 1 ? prev + 1 : 0))
            }
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 p-2 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-colors focus:outline-none z-10"
            aria-label="Next image"
          >
            <ChevronRight size={24} className="text-gray-700" />
          </button>
        </>
      )}
      {currentItem && (
        <div className="flex justify-center">
          <div className="w-full max-w-2xl">
            <ImageItem
              item={currentItem}
              index={carouselIndex}
              lightboxEnabled={data.lightbox}
              lazyLoading={data.lazyLoading}
              captionPosition={data.captionPosition}
              aspectRatio={data.aspectRatio}
              captionColor={colors.captionColor}
              imageRefs={imageRefs}
              onImageClick={onImageClick}
            />
          </div>
        </div>
      )}
      {filteredItems.length > 1 && (
        <div className="flex justify-center gap-2 mt-6">
          {filteredItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCarouselIndex(index)}
              className={`w-2 h-2 rounded-full transition-colors focus:outline-none ${
                index === carouselIndex ? 'bg-gray-800' : 'bg-gray-300'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
